module.exports = __webpack_public_path__ + "static/media/youtube.9f480b4f.svg";